import { jsxs as o, jsx as r } from "react/jsx-runtime";
import "react";
import "../../../index-D7lh-hNF.js";
import { Button as d } from "../../forms/button/index.js";
import '../../../assets/works.css';const m = "_works_pgm55_1", e = {
  works: m,
  "works--info": "_works--info_pgm55_9",
  "works--info--certify": "_works--info--certify_pgm55_12",
  "works--info--certify--subtitle": "_works--info--certify--subtitle_pgm55_14",
  "works--info--certify--title": "_works--info--certify--title_pgm55_17",
  "works--info--tech--title": "_works--info--tech--title_pgm55_20",
  "works--info--certify--paragraph": "_works--info--certify--paragraph_pgm55_23",
  "works--info--tech": "_works--info--tech_pgm55_20",
  "works--info--tech--paragraph": "_works--info--tech--paragraph_pgm55_32",
  "works--info--tech--action": "_works--info--tech--action_pgm55_36",
  "works--reports": "_works--reports_pgm55_39",
  "works--info--reports": "_works--info--reports_pgm55_43"
};
function w({
  certifySubtitle: a = "Verifica la legalidad de tu propiedad",
  certifyTitle: s = "Certificación Inmobiliaria de confianza",
  certifyParagraph: n = "Bohiio brinda un servicio integral de Certificación Inmobiliaria que minimiza el riesgo en tus operaciones. Antes de comprar o vender una propiedad, es fundamental realizar estudios exhaustivos para prevenir sorpresas desagradables al cerrar el trato. Nuestro compromiso es proporcionar a nuestros clientes las herramientas necesarias para evitar cualquier tipo de estafa inmobiliaria.",
  techTitle: t = "Cómo Funciona Bohiio",
  techParagraph: c = "Nuestra tecnología permite a los usuarios verificar cualquier propiedad simplemente marcando su ubicación en nuestro mapa o enviándonos un documento de referencia del inmueble. Una vez completado el proceso de verificación, recibes un informe detallado con todos los aspectos relevantes de la propiedad. Además, si la propiedad no está regularizada, proporcionamos recomendaciones gratuitas para su regularización. Todo esto en un plazo de 24 a 48 horas laborales.",
  techButtonContent: l = "Obtener cupón de descuento",
  onClickTechButton: p = () => {
  },
  imageContent: i = /* @__PURE__ */ r("div", {})
}) {
  return /* @__PURE__ */ o("section", { className: `${e.works}`, children: [
    /* @__PURE__ */ o("article", { className: `${e["works--info"]}`, children: [
      /* @__PURE__ */ o("div", { className: `${e["works--info--certify"]}`, children: [
        /* @__PURE__ */ r(
          "h5",
          {
            className: `${e["works--info--certify--subtitle"]} b-mb-4 md:b-mb-2`,
            children: a
          }
        ),
        /* @__PURE__ */ r(
          "h1",
          {
            className: `${e["works--info--certify--title"]} b-mb-6 md:b-mb-2`,
            children: s
          }
        ),
        /* @__PURE__ */ r("p", { className: `${e["works--info--certify--paragraph"]}`, children: n })
      ] }),
      /* @__PURE__ */ r("figure", { className: `${e["works--info--reports"]}`, children: i }),
      /* @__PURE__ */ o("div", { className: `${e["works--info--tech"]}`, children: [
        /* @__PURE__ */ r("h1", { className: `${e["works--info--tech--title"]}`, children: t }),
        /* @__PURE__ */ r(
          "p",
          {
            className: `${e["works--info--tech--paragraph"]} b-mb-6 md:b-mb-0`,
            children: c
          }
        ),
        /* @__PURE__ */ r("div", { className: `${e["works--info--tech--action"]}`, children: /* @__PURE__ */ r(d, { onClick: p, styleType: "link", children: l }) })
      ] })
    ] }),
    /* @__PURE__ */ r("figure", { className: `${e["works--reports"]}`, children: i })
  ] });
}
export {
  w as default
};
